import React from 'react';
import { FaExclamationTriangle, FaHome, FaArrowLeft } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-pl_bg_light_5 to-pl_bg_light_3 flex items-center justify-center">
      <div className="text-center max-w-md mx-auto px-4">
        <div className="mb-8">
          <FaExclamationTriangle className="mx-auto text-6xl text-pl_prim_color_1 mb-4" />
          <h1 className="text-4xl font-bold text-pl_txt_light_1 mb-4">404</h1>
          <h2 className="text-2xl font-semibold text-pl_txt_light_2 mb-2">Page Not Found</h2>
          <p className="text-pl_txt_light_3 mb-8">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>
        
        <div className="space-y-4">
          <Link
            to="/chatlogs"
            className="inline-flex items-center gap-2 bg-gradient-to-r from-pl_prim_color_1 to-pl_prim_color_2 text-pl_bg_light_3 px-6 py-3 rounded-lg font-semibold hover:from-pl_prim_color_2 hover:to-pl_prim_color_1 transition-all duration-200"
          >
            <FaHome />
            Go to Chat Logs
          </Link>
          
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center gap-2 text-pl_prim_color_1 hover:text-pl_prim_color_2 px-6 py-3 rounded-lg font-semibold transition-all duration-200"
          >
            <FaArrowLeft />
            Go Back
          </button>
        </div>
        
        <div className="mt-8 text-sm text-pl_txt_light_3">
          <p>Available pages:</p>
          <div className="mt-2 space-y-1">
            <Link to="/" className="block text-pl_prim_color_1 hover:text-pl_prim_color_2">
              / - Home
            </Link>
            <Link to="/chatlogs" className="block text-pl_prim_color_1 hover:text-pl_prim_color_2">
              /chatlogs - Chat Logs
            </Link>
            <Link to="/translatelogs" className="block text-pl_prim_color_1 hover:text-pl_prim_color_2">
              /translatelogs - Translation Logs
            </Link>
            <Link to="/translate" className="block text-pl_prim_color_1 hover:text-pl_prim_color_2">
              /translate - Translation Logs (Alternative)
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage; 